import { Injectable } from '@angular/core';
import { ConfigService } from './config.service';
import { HttpServiceService } from './http-service.service';

export interface insuranceDetails {
  insuranceProductId: number,
  internalId: string,
  nickName: string,
  policyStage: string,
  leadId: string,
  proposalId: string,
  policyNo: string,
  quotationNo: string,
  customerCode: string,
  customerName: string,
  customerId: string,
  insuranceCompanyCode: string,
  insuranceCompanyName: string,
  insuranceCompanyShortName: string,
  productCode: string,
  productName: string,
  packageCode: string,
  packageName: string,
  policyIssueDate: string,
  policyStartDate: string,
  policyEndDate: string,
  policyStatus: string,
  policyDueDays: string,
  sumInsuredAmount: string,
  premiumAmount: string,
  vatRate: string,
  vatAmount: string,
  totalPremiumAmount: string,
  transactionId: string,
  vendor: string,
  underReview: string,
  displayFlag: string,
  renewalInternalId: null,
  renewalStatus: null,
  motorInsuredDetail: {
    chassisNumber: string,
    regestrationNo: string,
    regestrationMonth: string,
    manufactureYear: string,
    noOfPassengers: string,
    driverAge: string,
    carMake: string,
    model: string
  },
  travelInsuredDetail: null,
  medicalInsuredDetail: [
    {
      policyNumber: string,
      cardNumber: string,
      dependentRelation: string,
      dependentIdNumber: string,
      dependentFullName: string,
      dependentDOB: string
    }]
}
@Injectable({
  providedIn: 'root'
})
export class InsuranceService {

  public GetBenefitsAndDocURL = "Insurance/GetBenefitsAndDoc"
  public GetDocumentURL = "Insurance/GetDocument"
  public GetClaimsListURL = "Insurance/GetClaimsList"
  public GetAssistanceListURL = "Insurance/GetAssistanceList"
  public UpdateNickNameURL = "Insurance/UpdateNickName"




  constructor(private config: ConfigService, private http: HttpServiceService,) { }

  public GetBenefitsAndDoc(proposalId, token) {

    return new Promise((resolve, reject) => {
      this.http.postToCloseApi(this.config.server + this.GetBenefitsAndDocURL, { proposalId: proposalId }, token).subscribe((res: any) => {

        console.log("GetBenefitsAndDoc", res);
        if (res?.response?.code == 1) {
          resolve(res)
        }
      },
        (Error) => {
          resolve(Error)
        })

    })
  }

  public GetDocument(proposalId, documentId, deliveryType, token) {

    return new Promise((resolve, reject) => {
      this.http.postToCloseApi(this.config.server + this.GetDocumentURL, { proposalId: proposalId, documentId: documentId, deliveryType: deliveryType }, token).subscribe((res: any) => {
        console.log("GetDocument", res);
        if (res?.response?.code == 1) {
          resolve(res)
        }
      },
        (Error) => {
          console.log("GetDocument", Error);
          resolve(Error)
        })
    })

  }



  public GetClaimsList(proposalId, token) {
    return new Promise((resolve, reject) => {
      this.http.postToCloseApi(this.config.server + this.GetClaimsListURL, {proposalId: proposalId}, token).subscribe((res: any) => {
        console.log("GetClaimsList", res);
        if (res?.response?.code == 1) {
          resolve(res)
        }
      },
        (Error) => {
          resolve(Error)
        })

    })
  }




  public GetAssistanceList(proposalId, token) {

    return new Promise((resolve, reject) => {
      this.http.postToCloseApi(this.config.server + this.GetAssistanceListURL, { proposalId: proposalId }, token).subscribe((res: any) => {

        console.log("GetAssistanceList", res);
        if (res?.response?.code == 1) {
          resolve(res)
        }
      },
        (Error) => {

          console.log("GetAssistanceList", Error);
          resolve(Error)
        })

    })
  }




  public UpdateNickName(InternalId, NickName, token) {

    return new Promise((resolve, reject) => {
      this.http.postToCloseApi(this.config.server + this.UpdateNickNameURL, { InternalId: InternalId, NickName: NickName }, token).subscribe((res: any) => {

        console.log("UpdateNickName", res);
        if (res?.response?.code == 1) {
          resolve(res)
        }
      },
        (Error) => {
          resolve(Error)
        })

    })
  }




}
